export function getChartData(
  financialDataRow,
  barThickness,
  budgetColor,
  realizedColor,
  lastYearRealizedColor,
  showLastYearRealized,
  compareArrayForOptions
) {
  return {
    labels: financialDataRow?.name,
    datasets: [
      {
        label: 'Réalisé',
        data: financialDataRow?.realized,
        backgroundColor: realizedColor,
        borderWidth: 1,
        order: 1,
        yAxisID: 'y2',
        barThickness: barThickness,
        datalabels: {
          anchor: 'end',
          textStrokeColor: 'white',
          textStrokeWidth: (context) =>
            compareArrayForOptions(context, financialDataRow.budget, 2, 0),
          align: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.budget,
              'end',
              'start'
            ),
          backgroundColor: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.budget,
              '',
              realizedColor
            ),
          color: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.budget,
              realizedColor,
              'white'
            ),
        },
      },
      {
        label: 'Budget',
        data: financialDataRow?.budget,
        backgroundColor: budgetColor,
        borderWidth: 1,
        order: 2,
        yAxisID: 'y1',
        barThickness: barThickness,
        datalabels: {
          anchor: 'end',
          textStrokeColor: 'white',
          textStrokeWidth: (context) =>
            compareArrayForOptions(context, financialDataRow.realized, 2, 0),
          align: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.realized,
              'end',
              'start'
            ),
          backgroundColor: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.realized,
              '',
              budgetColor
            ),
          color: (context) =>
            compareArrayForOptions(
              context,
              financialDataRow.realized,
              '#31799e',
              'white'
            ),
        },
      },
      showLastYearRealized && {
        label: 'Réalisé N-1',
        data: financialDataRow?.lastYearRealized,
        backgroundColor: lastYearRealizedColor,
        borderWidth: 1,
        yAxisID: 'y3',
        barPercentage: 0.2,
        barThickness: barThickness * 0.2,
        datalabels: {
          anchor: 'start',
          align: 'end',
          backgroundColor: lastYearRealizedColor,
          color: 'white',
        },
      },
      {
        // Gost colum used only to show the percentage
        label: 'Ratio',
        data: financialDataRow?.budget,
        order: 3,
        yAxisID: 'y4',
        barThickness: barThickness,
        datalabels: {
          color: 'white',
          textStrokeColor: 'black',
          textStrokeWidth: 1,
          anchor: 'start',
          align: 'end',
          padding: { left: 200 },
          font: { size: 16 },
          formatter: function (value, context) {
            const budgetValue = financialDataRow.budget[context.dataIndex]
            const realizedValue = financialDataRow.realized[context.dataIndex]

            if (
              !isFinite(budgetValue) ||
              budgetValue === 0 ||
              !isFinite(realizedValue)
            ) {
              return ''
            }

            const ratio = (realizedValue / budgetValue) * 100

            if (!isFinite(ratio) || ratio === 0) {
              return ''
            }

            return `${ratio.toFixed(0)}% Budget`
          },
        },
      },
    ].filter(Boolean),
  }
}
